import { render, staticRenderFns } from "./game_history.vue?vue&type=template&id=1ff37223&scoped=true"
import script from "./game_history.vue?vue&type=script&lang=js"
export * from "./game_history.vue?vue&type=script&lang=js"
import style0 from "./game_history.vue?vue&type=style&index=0&id=1ff37223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff37223",
  null
  
)

export default component.exports